// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_O3x","cls2":"PaperClaiming-cls2_zbq PaperClaiming-cls1_O3x"};